import { FC } from 'react';

import { CenterModal } from 'shared/components';
import { Icon, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	onClose: () => void;
	projectId: number;
	user_email: string;
	shared_user_emails: string[];
	handleClick: any;
	ownProject: boolean;
}

export const EditShareProjectModal: FC<Props> = ({
	onClose,
	user_email,
	shared_user_emails,
	handleClick,
	ownProject
}: Props) => {
	return (
		<CenterModal onClose={onClose} icon="users" iconColor="green" title="Shared with">
			<div className={styles.body}>
				<Text variant="inter/14/regular" color="grey">
					This project is currently shared with the following people. You can remove access at any time.
				</Text>
				<div className={styles.inline}>
					<Text variant="inter/16/regular">{user_email}</Text>
					<Text variant="inter/15/semi" color="grey">
						Owner
					</Text>
				</div>
				{shared_user_emails.map(email => (
					<div className={styles.inline}>
						<Text variant="inter/16/regular">{email}</Text>
						{ownProject && (
							<Icon icon="trash-full" size={20} className={styles.icon} onClick={handleClick(email)} />
						)}
					</div>
				))}
			</div>
		</CenterModal>
	);
};
